module.exports = __webpack_public_path__ + "img/tr.bd636c75.png";